import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Person from "@material-ui/icons/Person";
import Popover from '@material-ui/core/Popover';
import SortOptionForm from 'components/Forms/SortOptionForm.jsx';
import { auth } from 'services/Auth';

const styles = theme => ({
  user: {
    display: 'inline-block'
  }
});

class LogoutPopover extends React.Component {
  state = {
    anchorEl: null,
  };

  handleClick = event => {
    this.setState({
      anchorEl: event.currentTarget,
    });
  };

  handleClose = () => {
    this.setState({
      anchorEl: null,
    });
  };

  handleLogout = async () => {
    await auth.logout()
    window.location.reload();
  }

  render() {
    const { classes } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);

    return (
      <div className={classes.user}>
        <IconButton
          aria-owns={open ? 'logout-popper' : undefined}
          aria-haspopup="true"
          variant="contained"
          color="inherit"
          onClick={this.handleClick}
          display='inline-block'
        >
          <Person />
        </IconButton>

        <Popover
          id="logout-popper"
          open={open}
          anchorEl={anchorEl}
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}

        >
          <Button variant="text" onClick={this.handleLogout}>
            Log Out
          </Button>
        </Popover>
      </div>
    );
  }
}

LogoutPopover.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LogoutPopover);
